import BusinessProcess from './businessProcess';
export default BusinessProcess;